export default __webpack_public_path__ + "static/media/payne.7f8e9cdc.png";